import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=54ff7d66"
import script from "./SignUp.js?vue&type=script&lang=js&external"
export * from "./SignUp.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports